import apiClient, { buildAuthHeaders, isRequestCanceled } from 'services/apiClient';

const fetchDailyVehicleData = async (chassis, token, options = {}) => {
    try {
        const response = await apiClient.get('shiftware/api/vehicledata/', {
            params: { chassis_number: chassis },
            headers: {
                'Content-Type': 'application/json',
                ...buildAuthHeaders(token),
            },
            ...(options.signal ? { signal: options.signal } : {}),
        });

        if (Array.isArray(response.data)) {
            const vehicleData = response.data.map(item => ({
                date: item.record_date,
                dailyMileage: item.daily_mileage,
                efficiency: item.efficiency
            }));
            return vehicleData;
        }
        return null;
    } catch (err) {
        if (isRequestCanceled(err) || options.signal?.aborted) {
            throw err;
        }
        return null;
    }
};

export { fetchDailyVehicleData };
